import React from "react";
import { useHistory } from "react-router-dom";
// Comps
import { IonPage } from "@ionic/react";
import MarginContainer from "components/common/MarginContainer/MarginContainer";
import Logo from "components/common/Logo/Logo";
// Css
import classes from "./Splash.module.scss";

const Splash: React.FC = () => {
  const history = useHistory();

  const handleClick = () => {
    setTimeout(() => history.push("/home"), 1000);
  };

  return (
    <IonPage>
      <MarginContainer className={classes.container} hasBackBtn={false}>
        <Logo onClick={handleClick} />
      </MarginContainer>
    </IonPage>
  );
};

export default Splash;
